import { render, staticRenderFns } from "./FormCreateMany.vue?vue&type=template&id=54422f4a&scoped=true"
import script from "./FormCreateMany.vue?vue&type=script&lang=js"
export * from "./FormCreateMany.vue?vue&type=script&lang=js"
import style0 from "./FormCreateMany.vue?vue&type=style&index=0&id=54422f4a&prod&lang=css&scoped=true"
import style1 from "./FormCreateMany.vue?vue&type=style&index=1&id=54422f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54422f4a",
  null
  
)

export default component.exports